import React from "react";
import { Car, KeyRound, Radio, Unlock, Cog, MapPin, Phone, ShieldCheck, Calendar, Wrench } from "lucide-react";
import { priceSheet, businessInfo, payments } from "../mock";
import { Button } from "./ui/button";

const iconMap = { Car, KeyRound, Radio, Unlock, Cog, MapPin, Wrench };

const PriceSheet = () => {
  return (
    <section id="pricing" className="py-20 lg:py-28 fire-bg-subtle relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-yellow-400 font-bold uppercase tracking-[0.3em] text-xs">Mobile Diagnostics &amp; Key Programming</span>
          <h2 className="mt-3 text-white font-extrabold text-3xl lg:text-5xl tracking-tight">
            <span className="text-fire">Price</span> <span className="text-gold-shine">Sheet</span>
          </h2>
          <div className="mt-3 h-1 w-24 mx-auto rounded-full bg-gradient-to-r from-red-600 to-yellow-500" />
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Straightforward pricing — no surprises, always lower than the dealership.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-5">
          {priceSheet.map((section, idx) => {
            const Icon = iconMap[section.icon] || Car;
            return (
              <div key={idx} className="brand-card rounded-xl overflow-hidden border border-red-900/30">
                <div className="flex items-center gap-3 px-5 py-3 bg-gradient-to-r from-red-700 via-red-600 to-red-900">
                  <Icon className="w-5 h-5 text-white" strokeWidth={2.2} />
                  <h3 className="font-extrabold text-white text-base uppercase tracking-wider">{section.section}</h3>
                  <span className="ml-auto text-yellow-300 text-xs font-bold uppercase tracking-widest">Price</span>
                </div>
                <div className="divide-y divide-zinc-800">
                  {section.rows.map((row, i) => (
                    <div key={i} className="flex items-center justify-between px-5 py-3.5 hover:bg-red-950/20 transition-colors">
                      <div className="flex items-center gap-2.5">
                        <span className="w-1.5 h-1.5 rounded-sm bg-red-600" />
                        <span className="text-zinc-200 text-sm">{row.name}</span>
                      </div>
                      <span className="font-extrabold text-yellow-400 text-base tracking-wide">{row.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust badge + payments */}
        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <div className="brand-card rounded-xl p-6 flex items-center gap-5 border border-yellow-500/30">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center shadow-lg shadow-yellow-900/40">
              <ShieldCheck className="w-7 h-7 text-black" strokeWidth={2.4} />
            </div>
            <div>
              <div className="text-yellow-300 font-bold text-sm uppercase tracking-widest">Fast Mobile Service</div>
              <div className="text-white text-lg font-bold">Guaranteed to beat the dealership</div>
            </div>
          </div>
          <div className="brand-card rounded-xl p-6 border border-red-900/30">
            <div className="text-red-400 font-bold text-xs uppercase tracking-[0.3em] mb-3">Accepted Payments</div>
            <div className="flex flex-wrap gap-2">
              {payments.map((p) => (
                <span key={p} className="px-3 py-1.5 rounded-md bg-zinc-900 border border-zinc-700 text-zinc-200 text-sm font-semibold">
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="bg-brand-red text-white font-semibold h-12 px-7 text-base pulse-ring">
            <a href={`tel:${businessInfo.phoneRaw}`}>
              <Phone className="w-4 h-4 mr-2" />
              Get a Quote · {businessInfo.phone}
            </a>
          </Button>
          <Button asChild variant="outline" className="h-12 px-7 text-base bg-white/5 border-yellow-500/40 text-yellow-300 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 font-semibold">
            <a href="/book">
              <Calendar className="w-4 h-4 mr-2" />
              Book a Service · $30 Deposit
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PriceSheet;
